module.exports = __WEBPACK_EXTERNAL_MODULE_336__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/add/operator/toPromise","commonjs2":"rxjs/add/operator/toPromise","amd":"rxjs/add/operator/toPromise"}
// module id = 336
// module chunks = 0 1